declare global {
  interface Window {
    ArdoizVisioInterface: {
      hangup: Function;
    };
    terminateVideoCallFromDevice: Function;
    
    ga: any;

    process: any;
  }
}

window.ArdoizVisioInterface = window.ArdoizVisioInterface || {
  hangup: () => console.error('No ArdoizVisioInterface is defined !'),
};

export const ArdoizVisioInterface = window.ArdoizVisioInterface;


// Env
export const ENV_MODE = import.meta.env.MODE;

export const DEV_ENV = import.meta.env.DEV;

export const PROD_ENV = import.meta.env.PROD;

export const TEST_ENV = ENV_MODE === 'test';

// globally declare process.env in browser for react-s3-uploader to work due to its dependency on util package using process.env
// do not do this in test environnement as it will break tests in CI
// TODO (FP-486) : replace react-s3-uploader with a better package ESM friendly to avoid this hack
if (!TEST_ENV) {
  window.process = {
    env: import.meta.env
  };
  window.global = window;
}


// URLs
export const HIBOU_URL = `${import.meta.env.VITE_HIBOU_URL as string || ''}/hibou`;

export const HIBOU_GRAPHQL_URL = `${HIBOU_URL}/graphql?is_ajax_request=true`;

export const LEGACY_FAMILY_PORTAL_URL = import.meta.env.VITE_LEGACY_FAMILY_PORTAL_URL;

// UI
export const ALWAYS_SHOW_ONBOARDING = import.meta.env.VITE_ALWAYS_SHOW_ONBOARDING;

export const ENABLE_NOTIFICATIONS = import.meta.env.VITE_ENABLE_NOTIFICATIONS;

// Video call
export const DISABLE_INCOMING_CALL = import.meta.env.VITE_DISABLE_INCOMING_CALL;

export const INCOMING_CALL_POLLING_INTERVAL = parseInt(import.meta.env.VITE_INCOMING_CALL_POLLING_INTERVAL as string) || 1000;

export const VIDEO_CALL_DOMAIN = import.meta.env.VITE_VIDEO_CALL_DOMAIN;

export const VIDEO_CALL_ERROR_REDIRECT_TIMEOUT = parseInt(import.meta.env.VITE_VIDEO_CALL_ERROR_REDIRECT_TIMEOUT as string) || 3000;

export const VIDEO_CALL_MISSING_PARTICIPANT_TIMEOUT = parseInt(import.meta.env.VITE_VIDEO_CALL_MISSING_PARTICIPANT_TIMEOUT as string) || 10000;

export const VIDEO_CALL_CALLING_IMAGE_CHANGE_DELAY = parseInt(import.meta.env.VITE_VIDEO_CALL_CALLING_IMAGE_CHANGE_DELAY as string) || 500;

export const VIDEO_CALL_POLLING_INTERVAL = parseInt(import.meta.env.VITE_VIDEO_CALL_POLLING_INTERVAL as string) || 300000;

// File upload
export const MAX_UPLOADED_DOCUMENT_SIZE = 20000000;

// Google Analytics
export const GA_TRACKER_ID = import.meta.env.VITE_GA_TRACKER_ID;
